import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atlas-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChipComponent {}
